import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    templateUrl: '404.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class P404Component {

  constructor() { }

}
